module.exports = __webpack_public_path__ + "images/1254106fc4167b7d8ae5df44590613a4.svg";